module.exports = __webpack_public_path__ + "img/offer-payment.9a4426ab.svg";